import Vue from 'vue';
import { api } from "../../services/Api.js";

export function add_album({ state }, payload ){

    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    
    // make api call
    return api
    .post(school,"add_album.php",payload)
    .then( result =>{ 
      return result;
    })
    .catch( error => {
      Vue.$toaster.toast("store: add_album: "+error);
      return error;
    })

   
    
  }